import { Injectable } from '@angular/core';
import { IApiResponseFa } from 'src/app/models/response/api';
import { IFacturation } from 'src/app/models/facturation'
import { CustomHttpService } from 'src/app/services/http/custom-http.service';


@Injectable()
export class FacturationService {
    private url: string = '/facturation';
    constructor(
        private _http: CustomHttpService
    ) { }

    async getFactures(): Promise<any> {
        const res = await this._http.get<any>(
            this.url.concat(`/factures`)
        );
        return res;
    }

    async postCancel (body: IFacturation): Promise<any> {
      console.log('body ------------------------------------', body);
      const res = await this._http.post<IApiResponseFa, IFacturation>(
        this.url.concat(`/cancel`),body
      );
      return res;
  }
}
